<template>
  <div class="record-box">
    <div class="record-title">
      <span class="record-back" @click="back('/question')">聊天室</span>  
      <span>&nbsp;&gt;&nbsp;聊天记录</span>
    </div>
    <div class="record-list" id="relevant" v-loading="loading" :element-loading-text="loadintText">
      <chatCard v-for="(item) in list" :key="item.id" :item="item" />
    </div>
  </div>
</template>

<script>
import chatCard from "@/components/ChatCard.vue";
import { CHAT_API_DATA } from "@/api/chat";
export default {
  components: {
    chatCard,
  },
  data() {
    return {
      page: 1,
      loading: false,
      loadintText: "数据加载中...",
      list: [],
    };
  },
  mounted() {
    this.getMessageList();
    this.$el.querySelector(".record-list").addEventListener("scroll", this.onScroll);
  },
  methods: {
    //监听滚动
    onScroll() {
      this.scroll = this.$el.querySelector(".record-list").scrollTop;
      if (this.scroll === 0) {
        this.page++;
        this.getMessageList();
      }
    },
    //获取聊天记录
    getMessageList() {
      const data = {
        page: this.page,
        limit: 10,
      };
      this.loading = true;
      CHAT_API_DATA.getMessageList(data)
        .then((res) => {
          this.loading = false;
          this.list = [...res.rows.reverse(), ...this.list];
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            message: "连接超时，请重试！",
            type: "warning",
          });
          console.log(err);
        });
    },
    back(url){
      this.$router.push(url + window.location.search)
    }
  },
  watch: {
    //监听list数据置底
    list: {
      handler() {
        this.$nextTick(() => {
          let contant = this.$el.querySelector(".record-list");
          console.log(this.$el.querySelector(".record-list"))
          if (this.page === 1) {
            this.oldScroll = contant.scrollHeight;
            contant.scrollTop = contant.scrollHeight;
            console.log(this.oldScroll)
          }else{
            contant.scrollTop = contant.scrollHeight - this.oldScroll;
            this.oldScroll = contant.scrollHeight;
            console.log(this.oldScroll)
          }
        });
      },
    },
  },
};
</script>

<style scoped>
	.record-box {
		width: 940px;
    float: left;
		overflow: hidden;
		background-color: #ffffff;
		box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
		border-radius: 10px;
		margin-top: 10px;
		padding: 15px 25px;
	}
.record-list {
  margin-top: 20px;
  min-height: 600px;
  max-height: 600px;
  overflow: hidden;
  overflow-y: scroll;
  background-color: #ffffff;
}
.record-list::-webkit-scrollbar {
  display: none;
}
.record-title {
  padding-bottom: 15px;
  font-size: 0.8rem;
  cursor: pointer;
  border-bottom: 1px solid #cccccc;
}
.record-back {
  color: #2270e6;
}
</style>